import React, { useEffect, useRef, useState } from 'react';
import { Upload, ScanSearch, Sparkles, FileCheck, Shield } from 'lucide-react';
import { howItWorksSteps } from '../data/mock';

const iconMap = {
  1: Upload,
  2: ScanSearch,
  3: Sparkles,
  4: FileCheck
};

const Solution = () => {
  const [visibleSteps, setVisibleSteps] = useState([]);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            howItWorksSteps.forEach((step, index) => {
              setTimeout(() => {
                setVisibleSteps((prev) => [...new Set([...prev, step.id])]);
              }, index * 200);
            });
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="solution" className="solution-section" ref={sectionRef}>
      <div className="section-container">
        <h2 className="section-title">Wie es funktioniert</h2>
        
        <div className="solution-steps">
          {howItWorksSteps.map((step, index) => {
            const Icon = iconMap[step.id];
            const isVisible = visibleSteps.includes(step.id);
            
            return (
              <div 
                key={step.id} 
                className={`solution-step ${isVisible ? 'visible' : ''}`}
              >
                <div className="step-number">{step.id}</div>
                <div className="step-icon">
                  <Icon size={40} />
                </div>
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
                
                {index < howItWorksSteps.length - 1 && (
                  <div className="step-connector"></div>
                )}
              </div>
            );
          })}
        </div>

        <div className="solution-security">
          <div className="security-badge">
            <Shield size={24} />
            <div className="security-text">
              <p className="security-title">Schweizer Datenschutz</p>
              <p className="security-description">
                Datenspeicherung gemäss Schweizer Datenschutzgesetz (DSG).<br />
                Automatische Löschung nach Abschluss.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Solution;
